import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * KnowledgeBaseLayout - Layout wrapper for knowledge base routes
 * Simply renders child routes via Outlet
 */
export const KnowledgeBaseLayout: React.FC = () => {
  return <Outlet />;
};

export default KnowledgeBaseLayout;
